//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stepper from "@/components/UI/Stepper";
import Float from "@/js/float";
export default {
    name: "pre-multi-repay",
    components: { stepper },
    props: ["preMultiRepay"],
    data() {
        const { maxPeriod, modelTag } = this.preMultiRepay;
        return {
            period: maxPeriod,
            isDetailShow: false,
            modelTag,
        };
    },
    computed: {
        surplusPeriod() {
            return this.preMultiRepay.unPayVos.length - this.period;
        },
        isRewardShow() {
            return (
                this.period === this.preMultiRepay.maxPeriod &&
                this.modelTag !== 4
            );
        },
    },
    methods: {
        minusError() {
            this.$toast("还款期数不可小于1期");
        },
        plusError() {
            this.$toast(
                `还款期数不可大于${this.preMultiRepay.maxPeriod}期${
                    this.modelTag === 2 ? "，还清请分两笔还款" : ""
                }`
            );
        },
        periodChange(period) {
            let sumAmount = 0;
            this.preMultiRepay.unPayVos
                .slice(0, period)
                .forEach(({ amount }) => {
                    sumAmount = Float.add(sumAmount, amount, 2);
                });
            this.$emit("stepper-change", sumAmount, period);
        },
    },
};
